
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "nuxt": {
    "buildId": "d3bf1414-fc25-4f94-813c-79ac04f6572d"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}

import cfg0 from "/home/prow/go/src/github.com/bittorrent/ads-content-website/app.config.ts"

export default /*@__PURE__*/ defuFn(cfg0, inlineConfig)
